export const fmt = {
  currency: (n, decimals = 2) =>
    n == null ? '—'
    : `$${parseFloat(n).toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })}`,

  number: (n, decimals = 2) =>
    n == null ? '—'
    : parseFloat(n).toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      }),

  percent: (n, decimals = 1) =>
    n == null ? '—' : `${(parseFloat(n) * 100).toFixed(decimals)}%`,

  date: (d) =>
    d ? new Date(d).toLocaleDateString('en-US', { month:'short', day:'numeric', year:'numeric' }) : '—',

  sqft: (n) => n == null ? '—' : `${parseFloat(n).toFixed(2)} sf`,

  initials: (name = '') =>
    name.split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase(),
};

export const STATUS_LABELS = {
  draft:       { label: 'Draft',       cls: 'badge-gray'   },
  open:        { label: 'Open',        cls: 'badge-blue'   },
  closed_won:  { label: 'Won',         cls: 'badge-green'  },
  closed_lost: { label: 'Lost',        cls: 'badge-red'    },
};

// Paso 3 familia (21-oct-2026): familia del trabajo (valores de quotes.job_family).
export const FAMILY_LABELS = {
  iron: { label: 'Iron',     cls: 'badge-bronze' },
  alu:  { label: 'Aluminum', cls: 'badge-blue'   },
};
export const NO_FAMILY = { label: 'Not set', cls: 'badge-orange' };
export const otherFamily = f => (f === 'iron' ? 'alu' : f === 'alu' ? 'iron' : null);

export const TIER_LABELS = {
  T1: { label: 'T1 — Retail',    cls: 'badge-gray'   },
  T2: { label: 'T2 — Builder',   cls: 'badge-blue'   },
  T3: { label: 'T3 — Developer', cls: 'badge-green'  },
};

export const ALERT_META = {
  LOW:  { label: '🔴 LOW',  cls: 'alert-low'  },
  OK:   { label: '✅ OK',   cls: 'alert-ok'   },
  HIGH: { label: '🟠 HIGH', cls: 'alert-high' },
};
